import { getWidgetStyles } from './theme'

let shadowRoot: ShadowRoot | null = null
let hostEl: HTMLElement | null = null

export function mountWidget(config: { zIndex?: number }): { shadow: ShadowRoot; host: HTMLElement; mount: HTMLElement } {
  if (shadowRoot && hostEl) {
    const mount = shadowRoot.querySelector('.rqd-root') as HTMLElement
    return { shadow: shadowRoot, host: hostEl, mount }
  }

  hostEl = document.createElement('div')
  hostEl.id = 'reqdesk-widget'
  hostEl.style.position = 'fixed'
  hostEl.style.zIndex = String(config.zIndex ?? 9999)
  hostEl.style.inset = '0'
  hostEl.style.pointerEvents = 'none'
  document.body.appendChild(hostEl)

  shadowRoot = hostEl.attachShadow({ mode: 'open' })

  const style = document.createElement('style')
  style.textContent = getWidgetStyles()
  shadowRoot.appendChild(style)

  const mount = document.createElement('div')
  mount.className = 'rqd-root'
  shadowRoot.appendChild(mount)

  return { shadow: shadowRoot, host: hostEl, mount }
}

export function unmountWidget(): void {
  if (hostEl) {
    hostEl.remove()
    hostEl = null
    shadowRoot = null
  }
}

export function getShadowRoot(): ShadowRoot | null {
  return shadowRoot
}
